import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reasons'
})
export class ReasonsPipe implements PipeTransform {

  reasons = [
    { name: 'Nestanak struje', code: 'power_outage' },
    { name: 'Nedostatak materijala', code: 'no_material' },
    { name: 'Otkaz mašine', code: 'machine_failure' },
    { name: 'Alat', code: 'tools' },
  ];

  transform(value: string): string {
    const reason = this.reasons.find(reason => reason.code === value).name
    return reason;
  }

}
